import AxiosCustom from "../../../../components/common/apiConfigPouyan/index";


export function save_online_contract_api(payload) {
  const config = {
    url: `/UpdateContract/SignOnlineContract/SignOnlineContract/${payload?.data?.Otp}`,
    method:'GET'
  };

  const data = {};


  const header = {
    ...payload?.headers
  }

  return AxiosCustom(config, data, header);
}
